import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { QrCodePipe } from '../../../pipes';

@Component({
    selector: 'ecm-mat-bottom-sheet-qr-code',
    templateUrl: 'material-botton-sheet-qr-code.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, QrCodePipe, TranslateModule],
})
export class MaterialBottonSheetQrCodeComponent {
    public qrCodeUrl = input<string>('');
    public e2e = input<string>('e2e-mat-bottom-sheet-qr-code');

    public i18nPath = 'material.bottomSheet.qrCode';
}
